import q from "q";
import { events } from "../utils/constants";
import { sendEvents } from "../utils/events";

var getUserItems = function () {
    var userData = {};
    var user = JSON.parse(localStorage.getItem('user'));
    if (user) {
        // userData.token = user.accessToken;
        // userData.userId = user.userProfile.loginId;
        // userData.tenantId = user.userProfile.tenantId;
        userData.email = user.email;
        userData.token = user.accessToken
        // userData.email = 'shreya.amitabh@jumbotail.com';
        // userData.email = 'ishmin.singh@jumbotail.com';
    }
    return userData;
}

var baseurl = process.env.REACT_APP_API_URL;

// http://172.31.26.90:9072/santa-attribute

var preProdUrl = "https://aggregatorservice-preprod.api.jumbotail.com:9072/";
// var preProdUrl = "http://172.16.124.155:9071/"

var http = function (tinurl, method, content) {
    const fetchStartTime = Date.now();
    var userData = getUserItems();
    var url = baseurl + tinurl;
    method.headers = {
        Accept: "*/*"
    };

    if (userData.email) {
        // method.headers['Authorization'] = 'Bearer ' + userData.token;
        method.headers['userid'] = userData.email;
        // method.headers['customerID'] = userData.customerID;
    }

    if (userData.token) {
        method.headers['Authorization'] = 'Bearer ' + userData.token;
    }


    if (method.params) {
        url = url + '?' + new URLSearchParams(method.params);
    }

    if (content) {
        method.headers["content-type"] = content;
    }
    method.credentials = "include";
    var deferred = q.defer();
    fetch(url, method)
        .then(response => {
            return response.json();
        })
        .then(response => {
            const fetchCompletedTime = Date.now();
            const properties = {
                endPoint: url,
                responseTimeinMs:
                    fetchCompletedTime - fetchStartTime + 'ms',
                statusCode: response.statusCode,
            };
            // console.log("Received " + tinurl + " response: ", response);
            if (response.statusCode !== 200) {
                sendEvents(events.API_CALL, {
                    ...properties,
                    status: 'FAILED',
                    error: response.error,
                });
                deferred.reject({ error: response.error });
                if (response.statusCode === 401) {
                    localStorage.clear();
                    window.location.reload();
                }
                return;
            }
            if (response.data) {
                sendEvents(events.API_CALL, {
                    ...properties,
                    status: 'SUCCESS',
                });
                deferred.resolve(response.data);
            } else {
                sendEvents(events.API_CALL, {
                    ...properties,
                    status: 'SUCCESS',
                });
                deferred.resolve(response);
            }
        })
        .catch(function (e) {
            console.log("Request to " + tinurl + " failed: ", e);
            deferred.reject(e);
        });
    return deferred.promise;
};
var httpPreProd = function (tinurl, method, content) {
    var userData = getUserItems();
    var url = preProdUrl + tinurl;
    method.headers = {
        Accept: "*/*"
    };

    if (userData.token) {
        method.headers['Authorization'] = 'Bearer ' + userData.token;
        method.headers['userid'] = userData.userId;
        method.headers['tenantId'] = userData.tenantId;
    }

    if (content) {
        method.headers["content-type"] = content;
    }
    method.credentials = "include";
    var deferred = q.defer();
    fetch(url, method)
        .then(response => {
            return response.json();
        })
        .then(response => {
            // console.log("Received " + tinurl + " response: ", response);
            if (response.statusCode !== 200) {
                deferred.reject({ error: response.error });
                if (response.statusCode === 401) {
                    localStorage.clear();
                    window.location.reload();
                }
                return;
            }
            if (response.data) {
                deferred.resolve(response.data);
            } else {
                deferred.resolve(response);
            }
        })
        .catch(function (e) {
            console.log("Request to " + tinurl + " failed: ", e);
            deferred.reject(e);
        });
    return deferred.promise;
};

var httpIngestion = function (tinurl, method, content) {
    var userData = getUserItems();
    var url = baseurl + tinurl;
    method.headers = {
        Accept: "*/*"
    };

    if (userData.token) {
        method.headers['Authorization'] = 'Bearer ' + userData.token;
        method.headers['userid'] = userData.userId;
        method.headers['tenantId'] = userData.tenantId;
    }

    if (content) {
        method.headers["content-type"] = content;
    }
    method.credentials = "include";
    var deferred = q.defer();
    fetch(url)
        .then(response => {
            if (response.status !== 200) {
                return response.json();
            }
            return response;
        })
        .then(response => {
            // console.log("Received " + tinurl + " response: ", response);
            if (response.statusCode && response.statusCode !== 200) {
                deferred.reject({ error: response.error });
                return;
            }
            if (response.data) {
                deferred.resolve(response.data);
            } else {
                var data = response;
                var mime = response.headers.get("Content-Type");
                var fileName = response.headers.get("Content-Disposition").match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                var name = fileName[1];
                deferred.resolve({ data: data, mime: mime, name: name });
                // deferred.resolve(response);
            }
        })
        .catch(function (e) {
            console.log("Request to " + tinurl + " failed: ", e);
            deferred.reject(e);
        });
    return deferred.promise;
}

var fileDownloadHttp = function (tinurl, method, content) {
    var userData = getUserItems();
    var deferred = q.defer();
    var url = baseurl + tinurl;
    method.headers = {
        Accept: "*/*"
    };

    if (userData.token) {
        method.headers['Authorization'] = 'Bearer ' + userData.token;
        method.headers['userid'] = userData.userId;
        method.headers['tenantId'] = userData.tenantId;
    }

    if (content) {
        method.headers["content-type"] = content;
    }
    method.headers['Access-Control-Allow-Origin'] = "*";
    method.credentials = "include";
    fetch(url, method)
        .then(function (response) {
            var data = response;
            var mime = response.headers.get("Content-Type");
            var fileName = response.headers.get("Content-Disposition").match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            var name = fileName[1];
            deferred.resolve({ data: data, mime: mime, name: name });
        })
        .catch(function (e) {
            console.log("Unable to process your request.", e);
            deferred.reject(e);
        });
    return deferred.promise;
};

const apiHandler = {
    post: function (url, data) {
        return http(url, { method: "POST", body: JSON.stringify(data) }, "application/json");
    },

    postPreProd: function (url, data) {
        return httpPreProd(url, { method: "POST", body: JSON.stringify(data) }, "application/json");
    },

    postIngestion: function (url, data) {
        return httpIngestion(url, { method: "POST", body: data });
    },

    put: function (url, data) {
        return http(url, { method: "PUT", body: JSON.stringify(data) }, "application/json");
    },

    // Alias to make GET API http calls.
    get: function (url, params) {
        return http(url, { method: "GET", params }, "application/json");
    },

    getPreProd: function (url, params) {
        return httpPreProd(url, { method: "GET" }, "application/json");
    },

    fileDownloadHttpGet: function (url, params) {
        return fileDownloadHttp(url, { method: "GET", params: params }, "application/json");
    },

    fileDownloadHttpPost: function (url, request) {
        return fileDownloadHttp(url, { method: "POST", body: JSON.stringify(request) }, "application/json");
    }
};

export default apiHandler;
